import { useSessionStore } from "../../../state/src/useSessionStore";

export type KioskLogContext = {
  kioskId?: string;
  locationName?: string;
  screenDurations?: unknown;
  senderName?: string;
  receiverName?: string;
};

const joinName = (...parts: unknown[]): string =>
  parts
    .filter((p) => typeof p === "string" && (p as string).trim().length > 0)
    .map((p) => (p as string).trim())
    .join(" ");

export function withKioskLogContext<T extends object>(
  body: T,
  extra?: Partial<KioskLogContext>,
): T & { _kioskLogContext: KioskLogContext } {
  const s = (useSessionStore as any).getState?.() || {};
  const ref = s.referenceNumberSearchResult || {};
  const senderFromRef = joinName(ref.SenderFirstName, ref.SenderLastName);
  const receiverFromRef = joinName(ref.ReceiverFirstName, ref.ReceiverLastName);
  const senderFromStore = joinName(
    s.senderFirstName,
    s.senderMiddleName,
    s.senderLastName,
    s.senderLastName2,
  );
  const receiverFromStore = joinName(
    s.receiverFirstName,
    s.receiverMiddleName,
    s.receiverLastName,
    s.receiverLastName2,
  );

  return {
    ...body,
    _kioskLogContext: {
      kioskId: s.kioskId || s.qrCodeNumber,
      locationName: s.locationName,
      screenDurations: s.recordedScreenDurations,
      senderName: senderFromRef || senderFromStore,
      receiverName: receiverFromRef || receiverFromStore,
      ...extra,
    },
  };
}
